export const isUserEmailDomainAllowed = (email: string, allowedDomains: string[]): boolean =>
  !allowedDomains?.length || allowedDomains.some(domain => email.includes(domain));
